exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-title {\r\n    padding-top: 10px;\r\n}\r\n\r\n.avatar {\r\n    display: block;\r\n    margin-left: 10px;\r\n}\r\n\r\n.avatar img {\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n}\r\n\r\n.active  {\r\n    background: #8e8e9a!important;\r\n    color: #fff!important;\r\n}\r\n\r\n.btn-tab {\r\n    padding: 5px 20px 5px 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/user/user.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/user/user.css
// module chunks = main